// extracted by mini-css-extract-plugin
module.exports = {"tipsSection":"BillCardContent_tipsSection_2A1Y0","tipsVariant":"BillCardContent_tipsVariant_249FI"};